import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [ready, setReady] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await http.get("/auth/me");
        // Staff tokens resolve to the raw nas_staff row (type=="staff"). Keep the
        // same shape the sidebar filter expects.
        if (data?.type === "staff") {
          setUser({
            id: data.id, email: data.email, name: data.name,
            role: `nas-${data.role}`, nas_id: data.nas_id, is_staff: true, type: "staff",
          });
        } else {
          setUser(data);
        }
      } catch {
        setUser(false);
      } finally {
        setReady(true);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await http.post("/auth/login", { email, password });
    if (data?.token) localStorage.setItem("token", data.token);
    setUser({ id: data.id, email: data.email, name: data.name, role: data.role });
    return data;
  };

  const staffLogin = async (email, password) => {
    const { data } = await http.post("/staff/login", { email, password });
    if (data?.token) localStorage.setItem("token", data.token);
    setUser({
      id: data.id, email: data.email, name: data.name,
      role: `nas-${data.role}`, nas_id: data.nas_id, is_staff: true,
    });
    return data;
  };

  const changePassword = async (current_password, new_password) => {
    await http.post("/auth/change-password", { current_password, new_password });
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, ready, login, staffLogin, changePassword, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
